/**
 * HUB Comms component created by karora on 24/03/17.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { HubComms } from '../types/hubcomms';

@Component({
  selector: 'hub-comms',
  templateUrl: './hubcomms.component.html',
  styleUrls: ['./hubcomms.component.css'],
  providers: [HubService],
})

export class HubCommsComponent implements OnInit {
  hubcomms: HubComms[];
  hubCommsObserver: Observable<HubComms[]>;
  private fromTimestamps: string[];
  errorMessage: string;
  headersVisible = 0;
  bodyVisible = 0;
  payloadVisible = 0;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('HubComms Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.later();
  }

  earlier(): void {
    let created: string = null;
    try {
      created = this.hubcomms[this.hubcomms.length - 1].created;
      if (!this.fromTimestamps) {
        this.fromTimestamps = <string[]> [];
      }
      this.fromTimestamps.push(this.hubcomms[0].created)
    } catch (err) {
      console.log(err);
    }
    this.hubCommsObserver = this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getComms(+params['hubid'], created))
    );
    this.hubCommsObserver
      .subscribe(hubcomms => this.hubcomms = hubcomms, err => HubCommsComponent.handleRefreshError(err));
  }

  later(): void {
    let created: string = null;
    try {
      created = this.fromTimestamps[this.fromTimestamps.length - 1];
      this.fromTimestamps = this.fromTimestamps.slice(0, -1);
    } catch (err) {}
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getComms(+params['hubid'], created))
    ).subscribe(hubcomms => this.hubcomms = hubcomms, err => HubCommsComponent.handleRefreshError(err));
  }

  Stringify(v: any): string {
    try {
      let s: string = JSON.stringify(v, null, 2);
      if (s.length > 8192) {
        this.errorMessage = 'Data is too long to show: ' + s.length + ' bytes.';
        console.log(this.errorMessage);
        return s.substr(0, 1000) + ' [....... elided ' + (s.length - 1500) + ' bytes .......] ' + s.substr(-500);
      } else {
        return s;
      }
    } catch (err) {
      this.errorMessage = 'Error stringifying data! ' + err;
      return this.errorMessage;
    }
  }

  showHeaders(uid: number): void {
    if (this.headersVisible === uid) {
      this.headersVisible = 0;
    } else {
      this.headersVisible = uid;
    }
  }

  showBody(uid: number): void {
    if (this.bodyVisible === uid) {
      this.bodyVisible = 0;
    } else {
      this.bodyVisible = uid;
    }
  }

  showRawPayload(uid: number): void {
    if (this.payloadVisible === uid) {
      this.payloadVisible = 0;
    } else {
      this.payloadVisible = uid;
    }
  }
}

